import { Info } from '@app/modules/audit/components/audit-result/Info';
import { AuditMatch, toTimestamp } from '@mi-front/core';
import { StreamEl, theme } from '@mi-front/ui';
import CampaignIcon from '@mui/icons-material/Campaign';
import { useTheme } from '@mui/material';
import { desaturate } from 'polished';
import Popup from 'reactjs-popup';
import { MatchMarker } from './elements';

interface Props {
  readonly match: AuditMatch;
}

export function AuditMatchMarker({ match }: Props) {
  const muiTheme = useTheme();
  return (
    <StreamEl key={match.datetime} ts={toTimestamp(match.datetime)} offsetX={-18} zIndex={10}>
      <Popup
        trigger={
          <MatchMarker color={desaturate(0.2, theme.orange)}>
            <CampaignIcon fontSize="small" style={{ marginTop: '-6px' }} />
          </MatchMarker>
        }
        position="bottom center"
        on="hover"
        contentStyle={{
          borderRadius: 6,
          minWidth: 200,
          width: 'auto',
          background: muiTheme.palette.background.paper,
          color: muiTheme.palette.text.primary,
          border: `1px solid ${muiTheme.palette.divider}`,
        }}
      >
        <Info match={match} />
      </Popup>
    </StreamEl>
  );
}
